import blog_1 from '../screenshots/blog-1.jpg';
import blog_2 from '../screenshots/blog-2.jpg';
import blog_3 from '../screenshots/blog-3.jpg';

const blogs = [
    {
        img: blog_1,
        name: 'How to use JS context API',
        link: 'https://kazi-mashry.medium.com/use-of-js-context-api-7fd8507dbdec',
        date: 'Sep 19, 2020'
    },
    {
        img: blog_2,
        name: 'Some confusing JS stuff',
        link: 'https://kazi-mashry.medium.com/some-confusing-js-stuff-861cb16199fc',
        date: 'Aug 08, 2020'
    }, 
    {
        img: blog_3,
        name: 'JS error handling',
        link: 'https://kazi-mashry.medium.com/js-error-handling-c45e32025bac',
        date: 'Nov 03, 2020'
    }
];

export default blogs;